import { useParams } from "@tanstack/react-router";
import { createFileRoute } from "@tanstack/react-router";
import { useBreadCrumbs } from "~/contexts/useBreadCrumbs";
import { MyProfilePage } from "~/pages/MyProfilePage";
import { queryClient, trpc } from "~/utils/trpc";

export const Route = createFileRoute("/_dashboard/$datasetSlug/profile")({
  component: RouteComponent,
  loader: async () => {
    const profile = await queryClient.fetchQuery(trpc.profile.get.queryOptions());
    return { profile };
  },
});

function RouteComponent() {
  const { datasetSlug } = useParams({ from: "/_dashboard/$datasetSlug" });
  const { profile } = Route.useLoaderData();
  useBreadCrumbs([{ title: "My Profile", link: `/${datasetSlug}/profile` }]);
  return <MyProfilePage profile={profile} />;
}
